import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Label, Input } from 'reactstrap';

const CheckboxCustom = props => (
  <Label className={classnames('custom-control custom-checkbox', props.className)}>
    <Input
      id={props.id}
      type="checkbox"
      name={props.name}
      checked={props.checked}
      className="custom-control-input"
      disabled={props.disabled}
      onChange={props.onChange}
    />
    <span className="custom-control-label">{props.label}</span>
  </Label>
);

CheckboxCustom.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CheckboxCustom;
